export enum WHITE_LABELS_LIST_ACTION {
    EDIT = 'white-label-edit',
    ENABLE = 'white-label-enable',
    DISABLE = 'white-label-disable',
    DESTROY = 'white-label-destroy',
}
